module.exports = __webpack_public_path__ + "img/taptap-top.40279cc0.png";